//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
import "../no/CaeObjectType.js";
import "../no/InferSnapType.js";
import "../no/ugmath.js";
let d=[[[0,"Value",1,"TaggedObject",0]],[[["selection","view","point"],"SetValue",{},3,0],[["selection","view","point"],"GetValue",{},0,0],[["snap_type","selection1","view1","point1","selection2","view2","point2"],"SetValueWithSnap",{},7,0],[["snap_type","selection1","view1","point1","selection2","view2","point2"],"GetValueWithSnap",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.SelectObject = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SelectObject";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;